<page-heading
  [title]="'attendance.panelList.pageTitle' | translate"
  [description]="'attendance.panelList.pageDescription' | translate"
/>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <form [formGroup]="formGroup">
          <div class="row g-2">
            <div class="col-xs-12 col-sm-9 input-trend-search">
              <input
                type="search"
                #searchBox
                class="form-control"
                [placeholder]="'attendance.panelList.search' | translate"
                [value]="searchString ?? ''"
                (keyup)="search(searchBox.value)"
              />
              <span class="mdi mdi-magnify search-icon ml-2"></span>
            </div>

            <div class="col-xs-12 col-sm-3 trend-datepicker">
              <mat-date-range-input
                [rangePicker]="picker"
                formGroupName="dateRange"
              >
                <input
                  matStartDate
                  [placeholder]="'attendance.panelList.startDate' | translate"
                  formControlName="dateStart"
                />
                <input
                  matEndDate
                  [placeholder]="'attendance.panelList.endDate' | translate"
                  formControlName="dateEnd"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="picker" />
              <mat-date-range-picker #picker>
                <mat-datepicker-actions>
                  <mat-select
                    class="input-field rounded-lg"
                    (selectionChange)="onPeriodChange($event)"
                    [placeholder]="'attendance.panelList.select' | translate"
                  >
                    <mat-option value="1">{{ 'attendance.panelList.today' | translate }}</mat-option>
                    <mat-option value="7">{{ 'attendance.panelList.last7Days' | translate }}</mat-option>
                    <mat-option value="15">{{ 'attendance.panelList.last15Days' | translate }}</mat-option>
                    <mat-option value="30">{{ 'attendance.panelList.last30Days' | translate }}</mat-option>
                    <mat-option value="60">{{ 'attendance.panelList.last60Days' | translate }}</mat-option>
                  </mat-select>
                  <button
                    mat-raised-button
                    matDatepickerApply
                    class="btnOk"
                    (click)="onPeriodChange($event)"
                  >
                    OK
                  </button>
                </mat-datepicker-actions>
              </mat-date-range-picker>
            </div>
            <!-- <div
              class="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-3 btn-group trend-button"
            >
              <button
                class="btn btn-success fw-bold"
                type="button"
                (click)="closeMenu()"
                [routerLink]="['/attendance/panel']"
              >
                Atendimentos <span class="mdi mdi-arrow-right"></span>
              </button>
            </div> -->
          </div>

          <div class="row g-2 mt-2">
            <div
              class="col-xs-12 col-md-6 col-lg-4 col-xl-3 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterChannel"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>{{ labelChannel }}</span>
              </button>
              <mat-menu #filterChannel="matMenu">
                @if (listChannel.length > 0) {
                  <button mat-menu-item (click)="searchByChannel(null)">
                    {{ 'attendance.panelList.all' | translate }}
                  </button>
                  @for (channel of listChannel; track $index) {
                    <button mat-menu-item (click)="searchByChannel(channel)">
                      {{ channel.name }}
                    </button>
                  }
                } @else {
                  <h6 class="text-muted m-1">{{ 'attendance.panelList.noResultsFound' | translate }}</h6>
                }
              </mat-menu>
            </div>

            @if (isAttendant() || isSupervisor()) {
              <div
                class="col-xs-12 col-md-6 col-lg-4 col-xl-3 btn-group trend-button"
              >
                <button
                  [matMenuTriggerFor]="filterDepartmentAtt"
                  type="submit"
                  class="btn btn-primary fw-bold mdi mdi-filter-variant d-block dropdown-toggle"
                >
                  <span>{{ labelDepartment }}</span>
                </button>
              </div>
              <mat-menu
                #filterDepartmentAtt="matMenu"
                class="custom-menu-panel"
              >
                <button mat-menu-item (click)="searchByDepartment(null)">
                  {{ 'attendance.panelList.all' | translate }}
                </button>
                @for (team of listTeamChannel; track $index) {
                  <button
                    mat-menu-item
                    (click)="searchByDepartment(team.department)"
                  >
                    {{ team.department.name }}
                  </button>
                }
              </mat-menu>
            }
            @if (isAdmin()) {
              <div
                class="col-xs-12 col-md-6 col-lg-4 col-xl-3 btn-group trend-button"
              >
                <button
                  [matMenuTriggerFor]="filterDepartmentAdm"
                  type="submit"
                  class="btn btn-primary fw-bold mdi mdi-filter-variant d-block dropdown-toggle"
                >
                  <span>{{ labelDepartment }}</span>
                </button>
              </div>
              <mat-menu
                #filterDepartmentAdm="matMenu"
                class="custom-menu-panel"
              >
                <button mat-menu-item (click)="searchByDepartment(null)">
                  {{ 'attendance.panelList.all' | translate }}
                </button>
                @for (department of listDepartmentChannel; track $index) {
                  <button
                    mat-menu-item
                    (click)="searchByDepartment(department)"
                  >
                    {{ department.name }}
                  </button>
                }
              </mat-menu>
            }

            <div
              class="col-xs-12 col-md-6 col-lg-4 col-xl-3 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterStatus"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>{{ labelStatus }}</span>
              </button>
              <mat-menu #filterStatus="matMenu" class="custom-menu-panel">
                <button mat-menu-item (click)="searchByStatus(null)">
                  {{ 'attendance.panelList.all' | translate }}
                </button>
                @for (status of listStatusAttendances; track $index) {
                  <button mat-menu-item (click)="searchByStatus(status)">
                    {{
                      status === "OVERTIME"
                        ? "Fora de horário"
                        : status === "PENDING"
                          ? "Aguardando"
                          : status === "IN_PROGRESS"
                            ? "Em andamento"
                            : status === "PAUSED"
                              ? "Pausado"
                              : status === "CLOSED"
                                ? "Fechado"
                                : "-"
                    }}
                  </button>
                }
              </mat-menu>
            </div>

            @if (isAdmin()) {
              <div
                class="col-xs-12 col-md-6 col-lg-4 col-xl-3 btn-group trend-button"
              >
                <button
                  [matMenuTriggerFor]="filterUserAdm"
                  type="submit"
                  class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
                >
                  <span>{{ labelUser }}</span>
                </button>
              </div>
              <mat-menu #filterUserAdm="matMenu" class="custom-menu-panel">
                <button mat-menu-item (click)="searchByUser(null)">
                  {{ 'attendance.panelList.all' | translate }}
                </button>
                @for (user of attendantsByTeam; track $index) {
                  <button mat-menu-item (click)="searchByUser(user)">
                    {{ user.name }}
                  </button>
                }
              </mat-menu>
            }
            @if (isSupervisor()) {
              <div
                class="col-xs-12 col-md-6 col-lg-4 col-xl-3 btn-group trend-button"
              >
                <button
                  [matMenuTriggerFor]="filterUserSup"
                  type="submit"
                  class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
                >
                  <span>{{ labelUser }}</span>
                </button>
              </div>
              <mat-menu #filterUserSup="matMenu" class="custom-menu-panel">
                <button mat-menu-item (click)="searchByUser(null)">
                  {{ 'attendance.panelList.all' | translate }}
                </button>
                @for (user of attendantsByTeam; track $index) {
                  <!-- @for (user of user.agents; track $index) { -->
                    <button mat-menu-item (click)="searchByUser(user)">
                      {{ user.name }}
                    </button>
                  <!-- } -->
                }
              </mat-menu>
            }
          </div>
        </form>
      </div>
    </div>
    @if (!loadingContent) {
      <div class="card-body mb-3">
        <div class="d-flex flex-wrap gap-2">
          <div class="flex-fill">
            <card-graphic-small-component
              [label]="'attendance.panelList.cardOvertime' | translate"
              [total]="attendancesOvertime.toString()"
            />
          </div>
          <div class="flex-fill">
            <card-graphic-small-component
              [label]="'attendance.panelList.cardPending' | translate"
              [total]="attendancesPending.toString()"
            />
          </div>
          <div class="flex-fill">
            <card-graphic-small-component
              [label]="'attendance.panelList.cardInProgress' | translate"
              [total]="attendancesInProgress.toString()"
            />
          </div>
          <div class="flex-fill">
            <card-graphic-small-component
              [label]="'attendance.panelList.cardPaused' | translate"
              [total]="attendancesPaused.toString()"
            />
          </div>
          <div class="flex-fill">
            <card-graphic-small-component
              [label]="'attendance.panelList.cardClosed' | translate"
              [total]="attendancesClosed.toString()"
            />
          </div>
        </div>
      </div>
    }
  </div>
</div>

<div class="card">
  @if (loadingContent) {
    <content-loading-list />
  }
  @if (!loadingContent && pager.total === 0) {
    <empty-records-component
      [message]="'attendance.panelList.emptyMessage' | translate"
      [subMessage]="'attendance.panelList.emptySubMessage' | translate"
      [icon]="'mdi mdi-alert-circle-outline'"
    />
  }
  @if (!loadingContent && pager.total > 0) {
    <div class="card-body table-responsive">
      <table class="table table-hover table-centered mb-0">
        <thead>
          <tr>
            <th class="text-primary-emphasis">{{ 'attendance.panelList.columnCustomer' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'attendance.panelList.columnProtocol' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'attendance.panelList.columnAgent' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'attendance.panelList.columnDepartment' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'attendance.panelList.columnStatus' | translate }}</th>
            <th><span class="sr-only"></span></th>
          </tr>
        </thead>
        <tbody>
          @for (item of pager.list; track item._id) {
            <tr (click)="showDetailsAttendanceHitory(item)">
              <td class="table-user">
                <p>{{ item?.contact?.name }}</p>
                @switch (getChannelType(item?.channel?._id ?? item?.channel)) {
                  @case ("CLOUD_API") {
                    <img
                      src="../../../assets/images/icon-whatsapp.svg"
                      [alt]="'attendance.panelList.altWhatsappBusiness' | translate"
                      class="rounded-circle icon-whatsapp"
                    />
                    <span
                      class="badge rounded-circle translate-middle"
                      [ngClass]="isHybridChannel(item?.channel?._id ?? item?.channel) ? 'channel-seal--hybrid' : 'text-success'"
                    >
                      <i class="mdi mdi-check-decagram"></i>
                    </span>
                  }
                  @case ("INSTAGRAM_API") {
                    <img
                      src="../../../assets/images/icon-instagram.png"
                      [alt]="'attendance.panelList.altInstagram' | translate"
                      class="me-2 rounded-circle"
                    />
                  }
                  @case ("MESSENGER_API") {
                    <img
                      src="../../../assets/images/icon-messenger.png"
                      [alt]="'attendance.panelList.altMessenger' | translate"
                      class="me-2 rounded-circle"
                    />
                  }
                  @case ("WEBCHAT_API") {
                    <i
                      class="mdi mdi-chat text-primary font-18 me-2"
                      [matTooltip]="'Webchat'"
                    ></i>
                  }
                  @case ("RCS_API") {
                    <img
                      src="../../../assets/images/Google-Messages.png"
                      alt="RCS"
                      class="me-2 rounded-circle"
                    />
                  }
                  @default {
                    <img
                      src="../../../assets/images/icon-whatsapp.svg"
                      [alt]="'attendance.panelList.altWhatsappUnofficial' | translate"
                      class="me-2 rounded-circle icon-whatsapp"
                    />
                  }
                }

                {{
                  getChannelName(item?.channel?._id ?? item?.channel)
                    | truncate: 15
                }}
              </td>

              <td>
                <div class="d-flex flex-column align-items-start gap-1">
                  <span>
                    {{
                      item.createdAt
                        | timezoneDate
                          : "DD/MM/YYYY HH:mm"
                          : getTimezoneCompanyCurrentUser()
                    }}
                  </span>
                  <span class="badge font-12 bg-secondary">{{
                    item.protocol
                  }}</span>
                </div>
              </td>

              <td class="table-user">
                @if (item?.user) {
                  <img
                    [src]="getImageUser($safeNavigationMigration(item?.user))"
                    [alt]="item?.user?.name || getNameOfUser($safeNavigationMigration(item?.user))"
                    class="me-2 rounded-circle icon-whatsapp"
                    (error)="onImageError($event)"
                  />
                }
                {{ item?.user?.name ?? getNameOfUser($safeNavigationMigration(item?.user)) ?? "-" }}
              </td>

              <td>
                <span class="d-flex gap-3 align-items-center">
                  @if (!!item?.department?.name) {
                    {{ item?.department?.name ?? "-" }}
                  } @else {
                    {{ getDepartmentName($safeNavigationMigration(item?.department)) ?? "-" }}
                  }
                </span>
              </td>

              <td>
                <span
                  class="badge text-capitalize font-14"
                  [ngClass]="{
                    'bg-success': item?.status === 'IN_PROGRESS',
                    'bg-warning': item?.status === 'PENDING',
                    'bg-danger': item?.status === 'OVERTIME',
                    'bg-primary': item?.status === 'PAUSED',
                    'bg-secondary': item?.status === 'CLOSED',
                  }"
                >
                  {{ translateStatus($safeNavigationMigration(item?.status)) }}
                </span>
              </td>

              <td>
                <div class="d-flex justify-content-end">
                  <button
                    class="btn btn-dropdown-list"
                    [matMenuTriggerFor]="menu"
                    type="button"
                    (click)="$event.stopPropagation()"
                    (mousedown)="$event.stopPropagation()"
                  >
                    <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
                  </button>
                  <mat-menu #menu="matMenu">
                    @if (showTransferButton(item)) {
                      <button
                        mat-menu-item
                        tabindex="0"
                        (click)="
                          openAssignedUserTransferModal(item);
                          $event.stopPropagation()
                        "
                      >
                        {{ 'attendance.panelList.transfer' | translate }}
                      </button>
                    }
                    <button
                      mat-menu-item
                      tabindex="0"
                      (click)="showDetailsAttendanceHitory(item)"
                    >
                      {{ 'attendance.panelList.viewAttendance' | translate }}
                    </button>
                  </mat-menu>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>

      @if (pager.total > pager.perPage) {
        <paginator [pager]="pager" (onPager)="loadPage($event)"></paginator>
      }
    </div>
  }
</div>
